import React from 'react';
import { CustomerOrderResponse } from '@/api/bol';
import { DeleteConfirmDialog } from '@/components/common/DeleteConfirmDialog';

export interface CustomerOrderDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  customerOrder: CustomerOrderResponse | null;
}

export const CustomerOrderDeleteDialog: React.FC<CustomerOrderDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  customerOrder,
}) => {
  return (
    <DeleteConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      itemType="customer-order"
      itemId={customerOrder?.id || ''}
    />
  );
};
